module.exports = __webpack_public_path__ + "images/category_lp/construction_equipment/store_images/3@2x_d823b9780d761addefd4efa7a6ae800b.png";